/* The figma extension runs in a null origin, so does not have access to the crypto api */
export function randomUUID() {
  if (typeof crypto !== 'undefined' && crypto?.randomUUID != null) {
    return crypto.randomUUID();
  }
  const r = () => randomHex() + randomHex() + randomHex() + randomHex();
  const a = r() + r();
  const b = r();
  const c = r();
  const d = r();
  const e = r() + r() + r();
  return `${a}-${b}-${c}-${d}-${e}`;
}

function randomHex() {
  return ((Math.random() * 16) | 0).toString(16);
}
